import axios from 'axios';
import {
  ErrorCode,
  ApiErrorResponse,
  PublicErrorParams,
} from 'libs/commons/src/lib/error-constants';

export interface NormalizedApiError {
  code: ErrorCode;
  messageKey: string;
  correlationId?: string;
  params?: PublicErrorParams;
}

function isErrorCode(value: unknown): value is ErrorCode {
  return (
    typeof value === 'string' &&
    Object.values(ErrorCode).includes(value as ErrorCode)
  );
}

export function normalizeApiError(error: unknown): NormalizedApiError {
  if (axios.isAxiosError<ApiErrorResponse>(error)) {
    const responseData = error.response?.data;

    if (isErrorCode(responseData?.code)) {
      return {
        code: responseData.code,
        messageKey: `controlErrors.${responseData.code}`,
        correlationId: responseData.correlationId,
        params: responseData.params,
      };
    }

    if (
      error.code === 'ECONNABORTED' ||
      error.code === 'ETIMEDOUT' ||
      error.message.toLowerCase().includes('timeout')
    ) {
      return {
        code: ErrorCode.NETWORK_TIMEOUT,
        messageKey: 'controlErrors.NETWORK_TIMEOUT',
      };
    }

    if (!error.response) {
      return {
        code: ErrorCode.NETWORK_ERROR,
        messageKey: 'controlErrors.NETWORK_ERROR',
      };
    }
  }

  return {
    code: ErrorCode.UNKNOWN_ERROR,
    messageKey: 'controlErrors.UNKNOWN_ERROR',
  };
}
